"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPanoramaList = void 0;
const tech_1 = require("../../../tech");
const PanoramaApi_map_1 = require("./PanoramaApi.map");
const Config_1 = require("../../../tech/Config");
const getPanoramaList = async (lau) => {
    if (!lau) {
        console.error("lau is not defined");
        return [];
    }
    const url = (0, Config_1.getConfigValue)("COMMON_API_BASE_PATH") + "/map/fce/select.php";
    const headers = (0, tech_1.getAdditionalHeaders)();
    const res = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            ...headers
        },
        body: (0, tech_1.toFormString)({
            method: "panorama",
            lau: lau + ""
        })
    });
    const json = await res.json();
    let list = json.data;
    const result = list.map((item) => (0, PanoramaApi_map_1.mapApiToPanoramaPoints)(item, lau));
    return result;
};
exports.getPanoramaList = getPanoramaList;
